<cf-frontend-sdk-cplace-control-skeleton
  [componentId]="componentId"
  [label]="label"
  [labelPosition]="labelPosition"
  [labelFor]="nativeFormComponentId"
  [validationMessage]="validationMessage"
  [validationSeverity]="validationSeverity"
  [alert]="alert"
  [required]="required"
  [editMode]="($editMode | async)!"
  [submitting]="submitting"
  [submitSuccess]="($submitSuccess | async)!"
  [submitDisabled]="($submitDisabled | async)!"
  [readonly]="readonly"
  [disabled]="disabled"
  (cancelButtonClick)="onCancel()"
>
  <div class="cf-frontend-sdk-cplace-single-select-dropdown-container" [class.cf-frontend-sdk-empty-value]="($showEmptyValue | async)!">
    <p-dropdown
      [group]="!!optionGroups"
      optionGroupChildren="options"
      [options]="displayOptions"
      [disabled]="disabled"
      [readonly]="readonly"
      [required]="required"
      [(ngModel)]="value"
      (ngModelChange)="onNgModelChange()"
      [resetFilterOnHide]="true"
      [showClear]="($showClear | async)! && clearable"
      dropdownIcon="hui hui-caret-down"
      [emptyMessage]="'cf-frontend-sdk.shared.noResults' | translate"
      [emptyFilterMessage]="'cf-frontend-sdk.shared.noResults' | translate"
      optionValue="value"
      [name]="label"
      [filterPlaceholder]="'cf-frontend-sdk.shared.search' | translate"
      [placeholder]="'cf-frontend-sdk.shared.selectValue' | translate"
      [filter]="true"
      [inputId]="nativeFormComponentId"
      [ariaFilterLabel]="'cf-frontend-sdk.shared.search' | translate"
      [virtualScroll]="!optionGroups"
      [itemSize]="32"
      [scrollHeight]="'120px'"
    >
      <ng-template let-item pTemplate="selectedItem">
        <span>{{ selectedGroupOptionLabel ?? item.label }}</span>
      </ng-template>
      <ng-template let-item pTemplate="options">
        <i class="cf-frontend-sdk-cplace-single-select-control-icon" [ngClass]="item.icon"></i>
        <span>{{ item.label }}</span>
      </ng-template>
      <ng-template let-group pTemplate="group">
        <i class="cf-frontend-sdk-cplace-single-select-control-icon" [ngClass]="group.icon"></i>
        <span>{{ group.label }}</span>
      </ng-template>
    </p-dropdown>
  </div>
</cf-frontend-sdk-cplace-control-skeleton>
